import React, { useCallback, useEffect } from 'react'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import ReactApexChart from "react-apexcharts"
import {
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import { ERROR_KEY } from '../../../Constants/MainKeys'
import { addPageSpinner, addRightSectionSpinner, removePageSpinner, removeRightSectionSpinner } from '../../../store/spinner/actions'
import AlertService from '../../../Services/alertService'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import ServerWatcher from '../TemporarilyUnavailable/ServerWatcher'

const AdminDashboard = (props) => {

  const dispatch = useDispatch();
  const title = "Admin Dashboard";
  const description = "";
  const { language } = useSelector(state => state.Languages);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);

  const [apexFields, setApexFields] = useState(null);

  useEffect(() => {
    setApexFields({
      options: {
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ["Jan", "Mar", "Jun", "Sep", "Dec"],
        }
      },
      series: [{
        name: '',
        data: generateRandomNumbers(5)
      }],
    })
  }, []);

  const generateRandomNumbers = (length) => {
    const numbers = [];
    for (let i = 0; i < length; i++) {
      const randomNumber = Math.floor(Math.random() * (100 - 10 + 1)) + 10;
      numbers.push(randomNumber);
    }
    return numbers;
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className='container-fluid'>


          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Admin Dashboard"
          />
          <Row>
            <Col lg={12}>
              <Row>
                {/* <Col sm={12}>
                      {
                        apexFields ?
                          <div id="area-chart" dir="ltr" className='border'>
                            <ReactApexChart
                              options={apexFields?.options}
                              series={apexFields?.series}
                              type="area"
                              height={350}
                              className="apex-charts"
                            />
                          </div>
                          : null
                      }
                    </Col> */}
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/agents`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-chevron-left-square text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Agents
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/organizations`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-chevron-up-circle text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Merchants
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/all-transactions`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-transfer-alt text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Transactions
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/instant-payment`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-link text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Instant Payments
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/payouts`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-money text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Payouts
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/reports`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-notepad text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Reports
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/promotions`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-map-alt text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Promotions
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
                <Col sm={6} lg={3}>
                  <Link className="text-dark" to={`/${language}/tickets`}>
                    <Card className='border border-primary rounded-3'>
                      <CardBody><div className="product-img position-relative">
                        <div className='d-flex justify-content-center mt-2'>
                          <i className="bx bx-envelope text-primary" style={{ fontSize: "50px" }}></i>
                        </div>
                      </div>
                        <div className="mt-4 text-center">
                          <h5 className="mb-3 text-truncate">
                            Tickets
                          </h5>
                        </div>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(AdminDashboard)